import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  Button,
  Card,
  Typography,
  CardContent,
  CardMedia,
} from "@mui/material";
import { Box } from "@mui/system";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ButtonGroup from "@mui/material/ButtonGroup";
import { map, sortBy, find } from "lodash";

import AssetList from "../../Components/List/SelectionList";
import Confirmation from "../../Components/Modal/Confirmation";
import { getPodcastInfo, getPodcastLearners, updatePodcast } from "./Services";
import { getFormatedDate, getFormatedTime } from "../../Js/TimeAndDate";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { userLogs, durationCalculate, getClassNames } from "../../Js/Common";
import RecordButtonForBroadcast from "../../Components/Media/RecordButtonForBroadcast";
import {
  getRolesBySiteUuid,
  getUsersByRoleId,
} from "../../Layouts/Users/Services";
import { joinByKeys } from "../../Js/Common";
import { uploadRecordBroadcastFile } from "../../Js/Common";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { removeBroadcastAudio } from "../Feed/Services";

import IconButton from "@mui/material/IconButton";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import DeleteIcon from "@mui/icons-material/Delete";
import AudioButton from "../../Components/Media/AudioButton";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const PodcastRecordingEdit = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const styleclass = useStyles();
  let { id } = useParams();

  // State
  const [podcastInfo, setPodcastInfo] = useState(null);
  const [learnerList, setLearnerList] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [classes, setClasses] = useState([]);
  const [allaudioArr, setAllaudiosArr] = useState([]);
  const [fullAudioBlob, setFullAudioBlob] = useState(null);
  const [outcomeObj, setOutcomeObj] = useState(null);
  const [allaudioArrWithStatus, setAllaudioArrWithStatus] = useState([]);
  const [anyUpdateStatus, setAnyUpdateStatus] = useState([]);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // React logic hooks
  useEffect(() => {
    if (userInfo) {
      const innerFunction = async () => {
        setClasses(await getClassNames(userInfo.site_uuid));
      };
      innerFunction();
    }
  }, [userInfo]);

  useEffect(() => {
    fetchPodcastInfo();
    dispatch(assignmentSliceActions.resetState());
    //dispatch(assignmentSliceActions.setDurationFlag(false));
    //setStartTime(Date.now());
  }, [classes]);

  // Fetch Assignment Information
  const fetchPodcastInfo = async () => {
    console.log("id", id);
    let podcastInfoData = await getPodcastInfo(id, userInfo.site_uuid);
    setPodcastInfo(podcastInfoData.data[0]);
    setOutcomeObj(podcastInfoData.data[0].outcome);
    let withStatusTemp = podcastInfoData.data[0].outcome.allAudioList.map(
      (val) => {
        return {
          ...val,
          status: "fromServer",
          modification: "no",
        };
      }
    );
    let filterArr = withStatusTemp.filter((val) => val.key != "fullAudio");
    setAllaudioArrWithStatus(filterArr);
    let learners = await getPodcastLearners(
      podcastInfoData.data[0].context.user_uuid,
      userInfo.site_uuid,
      [true, false]
    );
    setLearnerList(
      sortBy(withClassName(learners.data), [
        "classname",
        (o) => {
          return o.name.firstname;
        },
      ])
    );
  };

  // To drop logs
  const logFunction = async (action, duration) => {
    let logResponse = await userLogs({
      actor: userInfo.uid,
      verb: "assignment",
      target: podcastInfo.uid,
      outcome: {
        value: "",
        action: action,
        duration: duration,
      },
      site_uuid: userInfo.site_uuid,
    });
  };

  const withClassName = (learners) => {
    return learners.map((val) => {
      return {
        ...val,
        classname: className(val.belongs_to),
      };
    });
  };

  const className = (id) => {
    console.log("classes", classes);
    let foundObj = find(classes, { id: id });
    if (foundObj) {
      return foundObj.value;
    }
    return "NA";
  };

  const uploadAudio = async () => {
    console.log("anyUpdateStatus",anyUpdateStatus);
    console.log("allAudios",allaudioArr);
    console.log("allAudiosstatus",allaudioArrWithStatus);
    if (anyUpdateStatus && anyUpdateStatus.length > 0) {
      dispatch(commonSliceActions.setLoader(true));
      let aliasArr = userInfo.username.split("@");
      console.log(":::::LLLLLLLL", anyUpdateStatus);
      // changes all path to file names
      let tempUpdatedStatus = anyUpdateStatus.filter(val => val.status == 'fromServer');
      tempUpdatedStatus = tempUpdatedStatus.map((val) => {
        let splitedArr = val.name.split("/");
        return {
          ...val,
          name: splitedArr[splitedArr.length - 1],
        };
      });

      // filter deleted and not deleted files
      let filterDeleted = tempUpdatedStatus.filter(
        (val) => val.modification == "deleted"
      );
      let filterWithoutDeleted = tempUpdatedStatus.filter(
        (val) => val.modification != "deleted"
      );

      filterDeleted = map(filterDeleted, "name");

      filterDeleted.push(podcastInfo.outcome.filename);
      console.log("filterDeleted", filterDeleted);
      console.log(":::::tempUpdatedStatus", tempUpdatedStatus);

      // upload new recorded files

      let filename = await uploadRecordBroadcastFile(
        [fullAudioBlob, ...allaudioArr],
        aliasArr[aliasArr.length - 1]
      );
      console.log("uploaded", filename);
      if (filename && filename.status == 200) {
        // remove already uploaded files
        const response = await removeBroadcastAudio({
          fileName: filterDeleted,
          aliasName: aliasArr[aliasArr.length - 1],
        });

        console.log("removed", response);

        // create json for outcome
        let oldFiles = filterWithoutDeleted.map((val) => {
          return {
            key: "audioClips",
            name: val.name,
          };
        });
        console.log("oldFiles", oldFiles);
        let fullAudio = null;
        let filesList = filename.data.map((value) => {
          if (value.contentType == "audio/mp3") {
            fullAudio = value.id;
            return {
              key: "fullAudio",
              name: value.id,
            };
          } else {
            return {
              key: "audioClips",
              name: value.id,
            };
          }
        });

        filesList.splice(1, 0, ...oldFiles);
        console.log("filesList", filesList);

        let updateRecord = await updatePodcast(
          {
            outcome: {
              filename: fullAudio,
              allAudioList: filesList,
              approvalStatus: null,
            },
          },
          id,
          userInfo.site_uuid
        );
        if (updateRecord && updateRecord.status == 200) {
          navigation("/Podcast");
          dispatch(commonSliceActions.setLoader(false));
        } else {
          alert("Something wrong!");
          dispatch(commonSliceActions.setLoader(false));
        }
      } else {
        alert("Something wrong!");
        dispatch(commonSliceActions.setLoader(false));
      }
    } else {
      setConfirmModal(true);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{}}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "space-around",
            pt: 2,
            pl: 3,
            pr: 7,
            backgroundColor: "#F5F7FF",
            overflow: "auto",
            width: "95%",
            marginLeft: 4,
            borderRadius: 5,
          }}
        >
          <Grid container xs={9} sx={{}}>
            {podcastInfo && (
              <Box>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Name: </b>{" "}
                  {podcastInfo?.context?.title
                    ? podcastInfo?.context?.title
                    : ""}
                </Typography>
                {podcastInfo?.context?.guest && (
                  <Typography
                    color="primary.main"
                    sx={{
                      lineHeight: 2,
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    <b>Guest:</b>{" "}
                    {podcastInfo?.context?.guest
                      ? podcastInfo?.context?.guest
                      : ""}
                  </Typography>
                )}
                {podcastInfo?.outcome?.commentByTrainer && (
                  <Typography
                    color="primary.main"
                    sx={{
                      lineHeight: 2,
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    <b>Comment by Trainer:</b>{" "}
                    {podcastInfo?.outcome?.commentByTrainer
                      ? podcastInfo?.outcome?.commentByTrainer
                      : ""}
                  </Typography>
                )}
              </Box>
            )}
          </Grid>
        </Grid>
        <Grid
          sx={{
            pt: 3,
            pl: 3,
            pr: 7,
            height: "78vh",
            overflowY: "auto",
            textAlign: "center",
            backgroundImage: `url(/podcastbg.png)`,
            backgroundSize: "100%",
            backgroundRepeat: "no-repeat",
          }}
          className={styleclass.scrollBar}
        >
          <RecordButtonForBroadcast
            alreadyRecorded={
              outcomeObj && outcomeObj.filename ? outcomeObj.filename : null
            }
            alreadyRecordedClips={
              allaudioArrWithStatus && allaudioArrWithStatus.length > 0
                ? allaudioArrWithStatus
                : []
            }
            updateAudioStatus={(data) => {
              setAnyUpdateStatus(data);
            }}
            // recordedAudio={(audio) => {
            //   setAudioLinks(audio, index);
            // }}
            // smartCheck={(data, filename) => {
            //   setSmartCheck(data, filename, index);
            // }}
            // uploadedAudioName={(filename) => {
            //   setFiles(filename, index);
            // }}
            fullAudio={(fullAudio) => {
              setFullAudioBlob(fullAudio);
            }}
            allAudios={(allaudios) => {
              setAllaudiosArr(allaudios);
            }}
            resetComponent={true}
            index={0}
            title={
              podcastInfo?.context?.title ? podcastInfo?.context?.title : ""
            }
            mode={"fromRejected"}
            audioDisable={false}
            submitFullAudio={uploadAudio}
          ></RecordButtonForBroadcast>
        </Grid>
        {/* {allaudioArr && allaudioArr.length > 0 && (
          <Button onClick={uploadAudio}>Submit</Button>
        )} */}
        <Confirmation
          image="error"
          primaryText="Please record new clip or edit exiting to submit again."
          alert={true}
          visible={confirmModal}
          toggleModal={(flag) => setConfirmModal(flag)}
        ></Confirmation>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default PodcastRecordingEdit;
